<template>
  <div id="content" class="dlnkmediatheque_books_admin container-fluid">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>


    <!-- Nav tabs -->
    <ul class="nav nav-tabs mt-2" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link active" id="books-tab" data-toggle="tab" href="#books" role="tab" aria-controls="home"
           aria-selected="true">Livres</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="loans-tab" data-toggle="tab" href="#loans" role="tab" aria-controls="loans"
           aria-selected="false">Prêts en cours</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="borrowers-tab" data-toggle="tab" href="#borrowers" role="tab"
           aria-controls="reservations" aria-selected="false">Emprunteurs</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="reservations-tab" data-toggle="tab" href="#reservations" role="tab"
           aria-controls="reservations" aria-selected="false">Réservations</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="game_reservations-tab" data-toggle="tab" href="#game_reservations" role="tab"
           aria-controls="game_reservations" aria-selected="false">Réservations de jeux</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="book_authors-tab" data-toggle="tab" href="#book_authors" role="tab"
           aria-controls="book_authors" aria-selected="false">Auteurs de livres</a>
      </li>

    </ul>

    <!-- Tab panes -->
    <div class="tab-content">

      <!-- Books -->
      <div class="tab-pane active" id="books" role="tabpanel" aria-labelledby="books-tab">
        <div class="row mt-2">

          <div class="col-12">

            <!-- search bar-->
            <form class="input-group input-group-merge row">
              <div class="form-group col-xs-12 col-md-9">
                <input type="search" class="form-control form-control-sm" placeholder="Chercher un livre"
                       aria-label="Chercher un livre" aria-describedby="search-book" v-model="query">
                <div class="input-group-append">
                <span class="input-group-text pr-5" id="search-book">
                  <i class="fas fa-search"></i>
                </span>
                </div>
              </div>
              <div class="form-group col-xs-12 col-md-3">
                <button type="button" class="btn btn-primary" @click="get_books_excel()">
                  Télécharger la liste des livres
                </button>
              </div>
            </form>
            <small v-if="search_message.length > 5" class="form-text text-muted d-block">{{ search_message }}</small>
            <!-- END search bar-->


            <!-- Pagination -->
            <div class="mt-2">
              <dlnkpagination
                  :page="page"
                  :page_count="page_count"
                  @next_page="next_page()"
                  @prev_page="prev_page()"
                  @set_page="set_page($event)">
              </dlnkpagination>
            </div>
            <!-- End Pagination -->

            <!-- books-->
            <div class="tab-wrapper">

              <table class="table">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Titre</th>
                  <th scope="col">Emplacement</th>
                  <th scope="col">Disponibilité</th>
                  <th scope="col">État</th>
                  <th scope="col">Retour</th>
                  <th scope="col">Emprunteur</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="book in books" :key="book.id">
                  <th scope="row">
                    <img class="img-fluid rounded-lg" style="width: 4rem;"
                         :src="'/modules/dlnkmediatheque/actions/get_file.php?uuid=' + book.uuid" alt="Book image">
                  </th>
                  <td>
                    <a :href="'/module/dlnkmediatheque/book?book_id=' + book.id">{{ book.title }}</a>
                  </td>
                  <td>{{ book.place_name }}</td>
                  <td>{{ book.available }}</td>
                  <td>TODO</td>
                  <td>TODO</td>
                  <td>TODO</td>
                  <td>
                    <a :href="'/module/dlnkmediatheque/edit_book?book_id=' + book.id"
                       class="btn btn-xs btn-icon btn-outline-primary rounded-circle"
                       data-toggle="tooltip" data-placement="top" title="Modifier le livre">
                      <i class="fas fa-edit"></i>
                    </a>
                    <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                       data-toggle="tooltip" data-placement="top" title="Supprimer le livre"
                       @click="delete_book(book.id)">
                      <i class="fas fa-trash"></i>
                    </a>

                  </td>
                </tr>

                </tbody>
              </table>

            </div>
            <!-- End Books  -->

            <!-- Pagination -->
            <dlnkpagination
                :page="page"
                :page_count="page_count"
                @next_page="next_page()"
                @prev_page="prev_page()"
                @set_page="set_page($event)">
            </dlnkpagination>
            <!-- End Pagination -->

            <!-- Divider -->
            <div class="d-lg-none">
              <hr class="my-7 my-sm-11">
            </div>
            <!-- End Divider -->
          </div>


        </div>


      </div>

      <!-- Borrowers -->
      <div class="tab-pane" id="borrowers" role="tabpanel" aria-labelledby="borrowers-tab">
        <div class="row mt-2">

          <div class="col-12">

            <!-- search bar-->
            <form class="input-group input-group-merge row">
              <div class="form-group col-xs-12 col-md-9">
                <input type="search" class="form-control form-control-sm" placeholder="Chercher un livre"
                       aria-label="Chercher un borrower" aria-describedby="search-borrowers" v-model="query_borrowers">
                <div class="input-group-append">
                <span class="input-group-text pr-5" id="search-borrowers">
                  <i class="fas fa-search"></i>
                </span>
                </div>
              </div>
            </form>
            <small v-if="search_message_borrowers.length > 5"
                   class="form-text text-muted d-block">{{ search_message_borrowers }}</small>
            <!-- END search bar-->

            <!-- borrowers-->
            <div class="tab-wrapper">

              <table class="table">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Nom</th>
                  <th scope="col">Nombre de livres</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="borrower in borrowers" :key="borrower.id">
                  <th scope="row">{{ borrower.customer_id }}</th>
                  <td>{{ borrower.name }}</td>
                  <td>{{ borrower.count }}</td>
                </tr>

                </tbody>
              </table>

            </div>
            <!-- End Books  -->

            <!-- Divider -->
            <div class="d-lg-none">
              <hr class="my-7 my-sm-11">
            </div>
            <!-- End Divider -->
          </div>


        </div>


      </div>

      <!-- Loans -->
      <div class="tab-pane" id="loans" role="tabpanel" aria-labelledby="loans-tab">
        <!-- Pagination -->
        <div class="mt-2">
          <dlnkpagination
              :page="loans_page"
              :page_count="loans_page_count"
              @next_page="next_loans_page()"
              @prev_page="prev_loans_page()"
              @set_page="set_loans_page($event)">
          </dlnkpagination>
        </div>
        <!-- End Pagination -->

        <!-- Loans -->
        <div class="tab-wrapper">

          <table class="table">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Titre</th>
              <th scope="col">Nom</th>
              <th scope="col">Date prêt</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="loan in loans" :key="loan.id">
              <th scope="row">
                {{ loan.id }}
              </th>
              <td>
                <a :href="'/module/dlnkmediatheque/book?book_id=' + loan.book_id">{{ loan.title }}</a>
              </td>
              <td>{{ loan.firstname }} {{ loan.lastname }}</td>
              <td>{{ loan.created_at }}</td>
            </tr>

            </tbody>
          </table>

        </div>
        <!-- End Loans  -->

        <!-- Pagination -->
        <dlnkpagination
            :page="loans_page"
            :page_count="loans_page_count"
            @next_page="next_loans_page()"
            @prev_page="prev_loans_page()"
            @set_page="set_loans_page($event)">
        </dlnkpagination>
        <!-- End Pagination -->
      </div>

      <!-- Book Reservations -->
      <div class="tab-pane" id="reservations" role="tabpanel" aria-labelledby="reservations-tab">

        <!-- Pagination -->
        <div class="mt-2">
          <dlnkpagination
              :page="reservations_page"
              :page_count="reservations_page_count"
              @next_page="next_reservations_page()"
              @prev_page="prev_reservations_page()"
              @set_page="set_reservations_page($event)">
          </dlnkpagination>
        </div>
        <!-- End Pagination -->

        <!-- Reservations -->
        <div class="tab-wrapper">

          <table class="table">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Titre</th>
              <th scope="col">Nom</th>
              <th scope="col">Emplacement</th>
              <th scope="col">Date demande</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="reservation in reservations" :key="reservation.id">
              <th scope="row">
                {{ reservation.id }}
              </th>
              <td>
                <a :href="'/module/dlnkmediatheque/book?book_id=' + reservation.book_id">{{ reservation.title }}</a>
              </td>
              <td>{{ reservation.firstname }} {{ reservation.lastname }}</td>
              <td>{{ reservation.place_name }}</td>
              <td>{{ reservation.created_at }}</td>
            </tr>

            </tbody>
          </table>

        </div>
        <!-- End Reservations  -->

        <!-- Pagination -->
        <dlnkpagination
            :page="reservations_page"
            :page_count="reservations_page_count"
            @next_page="next_reservations_page()"
            @prev_page="prev_reservations_page()"
            @set_page="set_reservations_page($event)">
        </dlnkpagination>
        <!-- End Pagination -->

      </div>

      <!-- Game Reservations -->
      <div class="tab-pane" id="game_reservations" role="tabpanel" aria-labelledby="game_reservations-tab">

        <!-- Pagination -->
        <div class="mt-2">
          <dlnkpagination
              :page="game_reservations_page"
              :page_count="game_reservations_page_count"
              @next_page="next_game_reservations_page()"
              @prev_page="prev_game_reservations_page()"
              @set_page="set_game_reservations_page($event)">
          </dlnkpagination>
        </div>
        <!-- End Pagination -->

        <!-- Game Reservations -->
        <div class="tab-wrapper">

          <table class="table">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Jeu</th>
              <th scope="col">Nom</th>
              <th scope="col">Emplacement</th>
              <th scope="col">Date demande</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="game_reservation in game_reservations" :key="game_reservation.id">
              <th scope="row">
                {{ game_reservation.id }}
              </th>
              <td>
                {{ game_reservation.game.title }}
              </td>
              <td>{{ game_reservation.customer.firstname }} {{ game_reservation.customer.lastname }}</td>
              <td>{{ game_reservation.game.place.name }}</td>
              <td>{{ game_reservation.creation }}</td>
            </tr>

            </tbody>
          </table>

        </div>
        <!-- End Game Reservations  -->

        <!-- Pagination -->
        <dlnkpagination
            :page="game_reservations_page"
            :page_count="game_reservations_page_count"
            @next_page="next_game_reservations_page()"
            @prev_page="prev_game_reservations_page()"
            @set_page="set_game_reservations_page($event)">
        </dlnkpagination>
        <!-- End Pagination -->

      </div>

      <!-- Book Authors -->
      <div class="tab-pane" id="book_authors" role="tabpanel" aria-labelledby="books-tab">
        <div class="row mt-2">

          <div class="col-12">

            <!-- search bar-->
            <form class="input-group input-group-merge row">
              <div class="form-group col-xs-12 col-md-9">
                <input type="search" class="form-control form-control-sm" placeholder="Chercher un auteur"
                       aria-label="Chercher un auteur" aria-describedby="search-book-author"
                       v-model="query_book_author">
                <div class="input-group-append">
                <span class="input-group-text pr-5" id="search-book-author">
                  <i class="fas fa-search"></i>
                </span>
                </div>
              </div>
            </form>
            <small v-if="search_book_author_message.length > 5"
                   class="form-text text-muted d-block">{{ search_book_author_message }}</small>
            <!-- END search bar-->

            <form>
              <div class="form-row align-items-center">
                <div class="col-sm-3 my-1">
                  <label class="sr-only" for="inlineFormInputFirstName">Prénom</label>
                  <input type="text" class="form-control form-control-sm" id="inlineFormInputFirstName"
                         placeholder="Prénom">
                </div>
                <div class="col-sm-3 my-1">
                  <label class="sr-only" for="inlineFormInputLastName">Nom</label>
                  <input type="text" class="form-control form-control-sm" id="inlineFormInputLastName"
                         placeholder="Nom">
                </div>
                <div class="col-auto my-1">
                  <button type="submit" class="btn btn-primary">Ajouter</button>
                </div>
              </div>
            </form>

            <!-- books-->
            <div class="tab-wrapper">

              <table class="table">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Prénom</th>
                  <th scope="col">Nom</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="author in authors" :key="author.id">
                  <th scope="row">{{ author.id }}</th>
                  <td>{{ author.firstname }}</td>
                  <td>{{ author.lastname }}</td>
                  <td>
                    <a href="javascript:void(0);"
                       class="btn btn-xs btn-icon btn-outline-primary rounded-circle"
                       data-toggle="tooltip" data-placement="top" title="Modifier l'auteur"
                       @click="edit_author(author.id)">
                      <i class="fas fa-edit"></i>
                    </a>
                    <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                       data-toggle="tooltip" data-placement="top" title="Supprimer l'auteur"
                       @click="delete_author(author.id)">
                      <i class="fas fa-trash"></i>
                    </a>

                  </td>
                </tr>

                </tbody>
              </table>

            </div>
            <!-- End Books  -->

            <!-- Divider -->
            <div class="d-lg-none">
              <hr class="my-7 my-sm-11">
            </div>
            <!-- End Divider -->
          </div>


        </div>


      </div>


    </div>


    <a href="#" title="admin e-bibliotheque" class="btn btn-primary mb-4">
      Retour à la bibliothèque
    </a>

  </div>


</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {

  props: [
    'admin',
    'customer_id'
  ],

  data: function () {
    return {
      page: Number,
      reservation: Array(),
      books: Array(),
      book_count: Number,
      page_count: Number,
      categories: Array(),
      genres: Array(),
      editors: Array(),
      authors: String(),
      query: String,
      query_book_author: String,
      search_message: String,
      search_book_author_message: String,
      search_reservation_message: String,
      message: "",
      message_type: "",
      reservations: Number,
      reservations_query: String,
      reservations_page: Number,
      reservations_count: Number,
      reservations_page_count: Number,

      game_reservations: Number,
      game_reservations_query: String,
      game_reservations_page: Number,
      game_reservations_count: Number,
      game_reservations_page_count: Number,

      loans: Number,
      loans_query: String,
      loans_page: Number,
      loans_count: Number,
      loans_page_count: Number,

      borrowers: Number,
      borrower_query: String,
      borrower_page: Number,
      borrower_count: Number,
      borrower_page_count: Number,
      query_borrowers: String,
      search_message_borrowers: String,

    }
  },

  mounted() {
    this.page = 1
    this.loans_page = 1
    this.reservations_page = 1
    this.game_reservations_page = 1
    this.query = ""
    this.query_book_author = ""
    this.message = ""
    this.message_type = ""
    this.get_data()

    this.borrowers = 0
    this.borrower_query = 0
    this.borrower_page = 1
    this.borrower_count = 0
    this.borrower_page_count = 0
    this.query_borrowers = ""
    this.search_message_borrowers = ""

  },

  watch: {
    page: function (new_val, old_val) {
      if (new_val < 1) {
        this.page = 1
      }
      if (new_val > this.page_count) {
        this.page = this.page_count
      }
      this.get_books()
    },

    loans_page: function (new_val, old_val) {
      if (new_val < 1) {
        this.loans_page = 1
      }
      if (new_val > this.loans_page_count) {
        this.page = this.loans_page_count
      }
      this.get_loans()
    },

    reservations_page: function (new_val, old_val) {
      if (new_val < 1) {
        this.reservations_page = 1
      }
      if (new_val > this.reservations_page_count) {
        this.reservations_page = this.reservations_page_count
      }
      this.get_reservations()
    },

    game_reservations_page: function (new_val, old_val) {
      if (new_val < 1) {
        this.game_reservations_page = 1
      }
      if (new_val > this.game_reservations_page_count) {
        this.game_reservations_page = this.game_reservations_page_count
      }
      this.get_reservations()
    },

    query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.search_message = ""
        this.get_data();
      } else if (new_val.length > 0) {
        this.search_message = "Veuillez taper au moins 3 caractères pour démarrer la recherche"
      }
    }
  },

  methods: {

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    delete_book(book_id) {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/book.php?book_id=' + parseInt(book_id);

      axios.delete(url)
          .then(function (response) {
            const status = response.data.status;

            if (status) {
              _this.message = "Livre supprimé"
              _this.message_type = "alert-success"
              _this.get_data()
            } else {
              _this.message = "Erreur"
              _this.message_type = "alert-danger"
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.message = "Erreur"
            _this.message_type = "alert-danger"
          })
          .then(function () {
            // always executed
          });
    },

    get_borrowers: function () {
      const _this = this;

      get_token_2().then(function (response) {
        let [secure_key, customer_id, api_url, customer] = response

        api_url += "mediatheque_loans/borrowers.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios({
          method: 'get',
          url: api_url,
        })
            .then(function (response) {
              _this.borrowers = response.data.borrowers
            })
            .catch(function (error) {
            })
            .then(function () {
                  // always executed
                }
            );
      })

    },


    get_books_excel: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_books.xlsx"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios({
        url: api_url,
        method: 'GET',
        responseType: 'blob',
      }).then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'livres.xlsx');
        document.body.appendChild(link);
        link.click();
      })
    },

    delete_reservation(reservation_id) {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/reservation.php?reservation_id=' + parseInt(reservation_id);

      axios.delete(url)
          .then(function (response) {
            const status = response.data.status;

            if (status) {
              _this.message = "Réservation supprimé"
              _this.message_type = "alert-success"
              _this.get_data()
            } else {
              _this.message = "Erreur"
              _this.message_type = "alert-danger"
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.message = "Erreur"
            _this.message_type = "alert-danger"
          })
          .then(function () {
            // always executed
          });
    },

    delete_game_reservation(reservation_id) {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/reservation.php?reservation_id=' + parseInt(reservation_id);

      axios.delete(url)
          .then(function (response) {
            const status = response.data.status;

            if (status) {
              _this.message = "Réservation supprimé"
              _this.message_type = "alert-success"
              _this.get_data()
            } else {
              _this.message = "Erreur"
              _this.message_type = "alert-danger"
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.message = "Erreur"
            _this.message_type = "alert-danger"
          })
          .then(function () {
            // always executed
          });
    },

    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    set_loans_page: function (page) {
      page = parseInt(page)
      this.loans_page = page
    },

    set_reservations_page: function (page) {
      page = parseInt(page)
      this.reservations_page = page
    },

    set_game_reservations_page: function (page) {
      page = parseInt(page)
      this.game_reservations_page = page
    },

    next_page: function () {
      this.page++
    },

    borrower_next_page: function () {
      this.borrower_page++
    },

    next_loans_page: function () {
      this.loans_page++
    },

    next_reservations_page: function () {
      this.reservations_page++
    },

    next_game_reservations_page: function () {
      this.game_reservations_page++
    },

    prev_loans_page: function () {
      this.loans_page--
    },

    prev_page: function () {
      this.page--
    },

    prev_reservations_page: function () {
      this.reservations_page--
    },

    prev_game_reservations_page: function () {
      this.reservations_page--
    },

    get_books: function () {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/books.php?page=' + _this.page + '&query=' + _this.query;

      axios.get(url)
          .then(function (response) {
            _this.books = response.data.books
            _this.book_count = response.data.book_count
            _this.page_count = response.data.page_count
            _this.categories = response.data.categories
            _this.editors = response.data.editors
            _this.genres = response.data.genres
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    get_loans: function () {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/loans.php?page=' + _this.loans_page;

      axios.get(url)
          .then(function (response) {
            _this.loans = response.data.loans
            _this.loans_count = response.data.loans_count
            _this.loans_page_count = response.data.loans_page_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    get_reservations: function () {
      let _this = this;
      let url = '/modules/dlnkmediatheque/actions/reservations.php?page=' + _this.reservations_page;

      axios.get(url)
          .then(function (response) {
            _this.reservations = response.data.reservations
            _this.reservations_count = response.data.count
            _this.reservations_page_count = response.data.page_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    delete_author: async function () {

    },

    edit_author: async function () {

    },

    get_game_reservations: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "/mediatheque_game_reservations.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id
      api_url += '&page=' + _this.page

      axios.get(api_url)
          .then(function (response) {
            _this.game_reservations = response.data.game_reservations
            _this.game_reservations_count = response.data.meta.count
            _this.game_reservations_page_count = response.data.meta.pages
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    get_data: function () {
      this.get_books()
      this.get_authors()
      this.get_loans()
      this.get_reservations()
      this.get_game_reservations()
      this.get_borrowers()
    },

    get_authors: async function () {
      let _this = this
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_authors.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.authors = response.data.authors
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

  }
}

</script>

<style scoped>

.tab-wrapper {
  border: 1px solid #e7eaf3;
  box-shadow: 0 0 35px rgba(140, 152, 163, .125);
  border-radius: .5rem;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
}

</style>